<template>
  <view-homepage />
</template>

<script setup>
import { onMounted } from 'vue';
import { useHead } from '#imports';
import { useMainStore } from '../stores/mainStore';
import { getMetadataAndTags } from '../helpers/metadata';
import ViewHomepage from '../components/ViewHomepage.vue';
import { clientWorkWindowEvent } from '../helpers/event-dispatch-helpers';

const mainStore = useMainStore();
const metadata = getMetadataAndTags(mainStore.settings.metadata, 'homepage', 'Home');

useHead({
  ...metadata.metaTitle,
  meta: metadata.metaTags,
});

onMounted(() => {
  clientWorkWindowEvent('homepage');
});
</script>
